import { IAssetCreate } from '../assets/interfaces';

export enum ActionStatus {
  Queued = 'queued',
  InProgress = 'in progress',
  Transcoding = 'transcoding',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

// TODO ActionTypes should to refactored into ActionType and AssetAccessLogActionType like the in the api

export interface IMetadata {
  label: string;
  value: string;
}

export enum ActionType {
  Upload = 'upload',
  Download = 'download',
  Create = 'create',
  Publish = 'publish',
  PushToCloud = 'push to cloud',
  PublishYahoo = 'publish to yahoo',
  PublishTwitter = 'publish to x',
  PublishYoutube = 'publish to youtube',
}

export interface INewAssetStatusParams {
  assetName: string;
  assetId: string;
  actionType: ActionType;
  actionStatus: ActionStatus;
  actionProgress?: string;
  videoType?: string;
  orgId?: number;
  deleted?: boolean;
  metadata?: IMetadata[];
}

export interface IUpdatedAssetStatusParams {
  assetName?: string;
  assetId?: string;
  actionDate?: string;
  actionType?: ActionType;
  actionStatus?: ActionStatus;
  actionProgress?: string;
  actionPriority?: string;
  user?: string;
  errorExchangeScheduleId?: string;
  errorAssetDetails?: IAssetCreate;
  metadata?: IMetadata[];
}

export interface IAssetStatus {
  _id: string;
  assetName: string;
  assetId: string;
  userId: number;
  actionType: ActionType;
  actionStatus: ActionStatus;
  actionPriority: string;
  actionProgress: string;
  user: string;
  actionDate: string;
  localizedActionDate?: string;
  actionMachine: string;
  exportFileName: string;
  errorMessage?: string;
  videoType: string;
  orgId: number;
  isVaultSuperAdmin: boolean;
  metadata?: IMetadata[];
}

export interface IAssetStatusCleanupParams {
  ids: Array<string>;
}
